"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrapBitDict = void 0;
const ediabasx_core_1 = require("@emdzej/ediabasx-core");
exports.TrapBitDict = {
    [ediabasx_core_1.EdiabasErrorCodes.EDIABAS_BIP_0002]: 2,
    [ediabasx_core_1.EdiabasErrorCodes.EDIABAS_BIP_0006]: 6,
    [ediabasx_core_1.EdiabasErrorCodes.EDIABAS_BIP_0009]: 9,
    [ediabasx_core_1.EdiabasErrorCodes.EDIABAS_BIP_0010]: 10,
    [ediabasx_core_1.EdiabasErrorCodes.EDIABAS_IFH_0001]: 11,
    [ediabasx_core_1.EdiabasErrorCodes.EDIABAS_IFH_0002]: 12,
    [ediabasx_core_1.EdiabasErrorCodes.EDIABAS_IFH_0003]: 13,
    [ediabasx_core_1.EdiabasErrorCodes.EDIABAS_IFH_0004]: 14,
    [ediabasx_core_1.EdiabasErrorCodes.EDIABAS_IFH_0005]: 15,
    [ediabasx_core_1.EdiabasErrorCodes.EDIABAS_IFH_0006]: 16,
    [ediabasx_core_1.EdiabasErrorCodes.EDIABAS_IFH_0007]: 17,
    [ediabasx_core_1.EdiabasErrorCodes.EDIABAS_IFH_0008]: 18,
    [ediabasx_core_1.EdiabasErrorCodes.EDIABAS_IFH_0009]: 19,
    [ediabasx_core_1.EdiabasErrorCodes.EDIABAS_IFH_0010]: 20,
    [ediabasx_core_1.EdiabasErrorCodes.EDIABAS_IFH_0011]: 21,
    [ediabasx_core_1.EdiabasErrorCodes.EDIABAS_IFH_0012]: 22,
    [ediabasx_core_1.EdiabasErrorCodes.EDIABAS_IFH_0013]: 23,
    [ediabasx_core_1.EdiabasErrorCodes.EDIABAS_IFH_0014]: 24,
    [ediabasx_core_1.EdiabasErrorCodes.EDIABAS_IFH_0015]: 25,
    [ediabasx_core_1.EdiabasErrorCodes.EDIABAS_IFH_0016]: 26,
    // 7.6.0+
    [ediabasx_core_1.EdiabasErrorCodes.EDIABAS_BIP_0011]: 8,
    [ediabasx_core_1.EdiabasErrorCodes.EDIABAS_IFH_0069]: 28,
    // 7.7.0+
    [ediabasx_core_1.EdiabasErrorCodes.EDIABAS_IFH_0074]: 29,
};
//# sourceMappingURL=trap-bits.js.map